import React from 'react';

import { LUMBER_TREATMENT_TYPES, LumberTreatmentType } from '@paragon/contract-library';
import { naturalSort } from '@paragon/utilities';

import { makeLumberTreatmentTypeHumanReadable } from '../../../../util';
import { LumberPropertySelectDialog } from './LumberPropertySelectDialog';
import { LumberSelectProps } from './LumberSelectProps';

const SORTED_TREATMENT_TYPES = LUMBER_TREATMENT_TYPES.toSorted(naturalSort);

export function LumberTreatmentTypesSelect(props: LumberSelectProps<LumberTreatmentType>) {
  return (
    <LumberPropertySelectDialog
      type="treatmentType"
      values={SORTED_TREATMENT_TYPES}
      selectedValues={props.value}
      onSelectedValuesChange={props.onChange}
      formatSingleValue={makeLumberTreatmentTypeHumanReadable}
      formatMultipleValues={(values) =>
        values.map(makeLumberTreatmentTypeHumanReadable).toSorted(naturalSort).join(', ')
      }
    />
  );
}
